import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";

function CreateMaterialOutputButton(props) {
    const { t } = useTranslation();
    const { id, schema, refresh, onSuccess, createButtonName, profileName, customizeErrorMsgCallback, ...others } =
        props;
    const [open, setOpen] = useState(false);
    const [modifiedSchema, setModifiedSchema] = useState();

    useEffect(() => {
        if (schema) {
            let modifiedSchema = cloneDeep(schema);

            for (const column of modifiedSchema.columns) {
                switch (column.name) {
                    case "ioState":
                        column.hideOnCreate = true;
                        column.disabled = true;
                        column.defaultValue = "출고";

                        break;

                    case "materialInOutputDate":
                        column.hideOnCreate = true;
                        column.disabled = true;

                        break;

                    case "username":
                        column.defaultValue = profileName;

                        break;

                    case "reasonAdjustment":
                        column.hideOnCreate = true;

                        break;

                    default:
                        break;
                }
                setModifiedSchema(modifiedSchema);
            }
        }
    }, [schema, profileName]);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        refresh.refresh();
    };

    return (
        <>
            <CreateRecordButtonLayout
                id={id + "create-button"}
                onClick={onOpen}
                createButtonName={createButtonName}
                {...others}
            />
            <AutoFormDialog
                id={id + "create-dialog"}
                mode="create"
                formId={id + "create-form"}
                title={schema ? t(`dialog.title.${schema.name}.${"output"}`) : ""}
                schema={modifiedSchema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>
    );
}

export default CreateMaterialOutputButton;
